<template>
  <el-dialog
    title="导出"
    :visible.sync="dialogInfo.show"
    width="700px"
    :close="close"
    :close-on-click-modal="false"
  >
  <div class="dia-content"> 
    <div style="margin-bottom: 24px;">正在导出班级报名学员：</div>
    <el-checkbox v-model="checked">
      同步导出学员近五年参加的学制为
      <el-input-number style="width: 100px;" v-model="num" :min="0" :controls="false"></el-input-number>
      天及以上的班级培训记录
    </el-checkbox>
  </div>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="close" title="取消"></butn>
      <butn btntype="primary" @click.native="submit" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { exportAudit } from "@/api/studyService/index.js";
import { ioRead } from "@/utils/common";
export default {
  components: { butn },
  props: ["dialogInfo"],
  data() {
    return {
      checked: true,
      num: 20,
    };
  },
  methods: {
    submit() {
      let params = {
        isTrainRecord: this.checked ? 1 : 0,
        filterDays: this.num,
        ...this.dialogInfo.searchParams
      }
      exportAudit(params).then((res) => ioRead(res));
    },
    close() {
      this.$emit("close");
    },
  },
  created() {

  },

  watch: {
    num(val) {
      if (val === null || val === undefined || val === '' || val < 0) {
        this.$nextTick(() => {
          this.num = 0;
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.c-dia {
  max-height: 390px;
  overflow: auto;
  border: 1px solid #dcdcdc;
  .head {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  }
}
.mt-10 {
  margin-top: 10px;
}

</style>
